export default __webpack_public_path__ + "static/media/dreamfest (11).451e9f95.jpg";